module.exports = __webpack_public_path__ + "static/media/boleto_disabled.90432eef.svg";